const ecosystems = [
  {
    name: "Ethereum",
    logo: require("@/assets/icons/networks/ethereum.svg"),
    description:
      "Ethereum is a global, open-source platform for decentralized applications.",
    projects: ["ethereum", "celer", "kyberdao", "skale", "thegraph"],
  },
  {
    name: "Tendermint",
    logo: require("@/assets/icons/networks/tendermint.svg"),
    description:
      "Tendermint is the best-in-class Byzantine-Fault Tolerant consensus engine for Proof-of-Stake networks.",
    projects: [
      "cosmos",
      "kava",
      "band",
      "terra",
      "starname",
      "switcheo",
      "persistence",
      "sentinel",
      "osmosis",
      "certik",
      "juno",
      "comdex",
      "lum",
      "gbridge",
      "evmos",
      "agoric",
      "injective",
      "akash",
      "sifchain",
      "archway",
      "terrav2",
      "passage3d",
      "quicksilver",
      "kujira",
      "celestia",
      "dydx",
      "dymension",
      "canto"
    ].sort((a, b) => a.localeCompare(b)),
  },
  {
    name: "Solana",
    altName: "Others",
    logo: require("@/assets/icons/networks/solana.svg"),
    description: "Solana is lorem ipsum.",
    projects: ["solana"],
    isOther: true,
  },
  {
    name: "Sui",
    altName: "Others",
    logo: require("@/assets/icons/networks/sui.svg"),
    description: "Sui is lorem ipsum.",
    projects: ["sui"],
    isOther: true,
  },
];

const groupByProject = () => {
  return ecosystems.reduce((acc, cur) => {
    const projects = cur.projects.reduce(
      (prjAcc, prjCur) => ({
        ...prjAcc,
        [prjCur]: { name: cur.name, altName: cur.altName, logo: cur.logo },
      }),
      {}
    );
    return { ...acc, ...projects };
  }, {});
};

export const ecosystemsSimplified = Object.values(
  ecosystems.reduce((acc, cur) => {
    const name = cur.isOther ? "Others" : cur.name;
    if (!acc[name]) {
      return {
        ...acc,
        [name]: {
          ...cur,
          name,
          description: "Others",
          logo: "",
        },
      };
    }
    acc[name].projects = [...acc[name].projects, ...cur.projects];
    return acc;
  }, {})
);

export default ecosystems;
export const projectMapEco = groupByProject();
